let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ekw50")).then(() => parcelRequire('aJoMX'));